// eslint-disable-next-line import/no-extraneous-dependencies
import _ from "lodash";
import { initializeApp } from "firebase/app";

const FirebaseApp = _.once(() =>
  initializeApp({
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  }),
)();

export default FirebaseApp;
